import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { RoleEditorPage } from '@/features/authorization/index.ts'

export const Route = createFileRoute('/_authenticated/system-management/roles/$roleId')({
  validateSearch: z.object({ tab: z.enum(['permissions', 'accounts']).catch('permissions').default('permissions') }),
  component: RoleEditPage
})
function RoleEditPage() {
  const navigate = Route.useNavigate()
  return (
    <RoleEditorPage
      roleId={Route.useParams().roleId}
      tab={Route.useSearch().tab}
      onTabChange={(tab) => void navigate({ search: { tab }, replace: true })}
    />
  )
}
